import React, { useContext, useState, useEffect}from 'react';
import axios from 'axios';
import { getAPIHostURL } from '../../../ClientConfig';
import { AppRelevantDataContext } from '../../../AppContext';
import { Row, Col } from 'antd';
import { FiInfo } from "react-icons/fi"; 
import { HHQI, PARAM_FOR_SHOWING_IMPACTS, LOW_SEVERE_L, LOW_SEVERE_U, GOOD_L, GOOD_U, SATISFACTORY_L, SATISFACTORY_U, MODERATE_L, MODERATE_U,
  POOR_L, POOR_U, V_POOR_L, V_POOR_U, HIGH_SEVERE_L, HIGH_SEVERE_U, LOW_SEVERE, GOOD, SATISFACTORY, MODERATE, POOR, V_POOR, HIGH_SEVERE,
  GOOD_PERCENT_U, SATISFACTORY_PERCENT_L, SATISFACTORY_PERCENT_U, MODERATE_PERCENT_U, MODERATE_PERCENT_L, POOR_PERCENT_L, POOR_PERCENT_U, VPOOR_PERCENT_L, VPOOR_PERCENT_U, SEVERE_PERCENT_U} from '../../../VcConstants';
import {IDS_ParamInfo, IDS_LoginServerIssue, IDS_RegistNetworkError,
   IDS_HHQI, IDS_HHQICritical, IDS_HHQIHighRisk, IDS_HHQICaution, IDS_HHQIAcceptable, IDS_HHQIHygienic, IDS_HHQIExcellent, IDS_WhatIsHHQI, IDS_HHQIInfo, IDS_DetailsAndRangesHHQI,
   IDS_status, IDS_Hygiene, IDS_HygieneMsgExcellent, IDS_HygieneMsgAcceptable, IDS_HygieneMsgHygienic, IDS_HygieneMsgCaution, 
   IDS_HygieneMsgHighRisk, IDS_HygieneMsgCritical} from '../../../VcLanguage';
import {Modal, ModalHeader, ModalBody } from 'reactstrap';
import VcInfoBox from './VcInfoBox';
import VcDetailsAndRanges from '../VcDetailsAndRanges';

const HHQIDashboard = (props) => {

  const context = useContext(AppRelevantDataContext);
  let appRelevantDataContextValue = context;
  let t = appRelevantDataContextValue.t; 

  const showHHQI = props.SingleDeviceParamValue == undefined ? false : true;
  const hhqiValue = props.SingleDeviceParamValue != null ? props.SingleDeviceParamValue : "0";
  const stdAirQualityRanges =  props.stdAirQualityRanges != null ? props.stdAirQualityRanges : {};

  const [state, setState] = useState({
          showImpactsOfParam: false,
          modalFromInfoButton: false,
          paramToShowDetailedInfo: "",
          backdropForInfoButton: 'static',
          stdAirQualityRanges: {}, // Easier to access individual parame from JSON object
          arrOfRanges: [],
          arrOfDispRangeValues: [],
          errors: {
              others: '',
          },
      });

      const ranges = [
        { label: t(IDS_HHQIExcellent), color: '#50C878' },
        { label: t(IDS_HHQIHygienic), color: '#9acd32' },
        { label: t(IDS_HHQIAcceptable), color: '#FFD700' },
        { label: t(IDS_HHQICaution), color: 'orange' },
        { label: t(IDS_HHQIHighRisk), color: 'red' },
        { label: t(IDS_HHQICritical), color: '#c00000' },
      ];

  // --- Helper Function to Determine Marker Color ---
  function getMarkerColor(value) { /* ... function remains the same ... */
    let singleParamAirQualityRange = {};

    try {
        singleParamAirQualityRange = stdAirQualityRanges[HHQI];
    } catch(e) {
        console.log(`Should not happen. Param [${HHQI}] was not found in stdAirQualityRange. Might happen during first Render.`);
    }

    if(singleParamAirQualityRange == null) {
        console.log(`Should not happen. Param [${HHQI}] was not found in stdAirQualityRange. Might happen during first Render.`);
    }

    let singleParamAirQualityRangeLowSevereL = singleParamAirQualityRange[LOW_SEVERE_L];
    let singleParamAirQualityRangeLowSevereU = singleParamAirQualityRange[LOW_SEVERE_U];
    let singleParamAirQualityRangeGoodL = singleParamAirQualityRange[GOOD_L];
    let singleParamAirQualityRangeGoodU = singleParamAirQualityRange[GOOD_U];
    let singleParamAirQualityRangeSatisfactoryL = singleParamAirQualityRange[SATISFACTORY_L];
    let singleParamAirQualityRangeSatisfactoryU = singleParamAirQualityRange[SATISFACTORY_U];
    let singleParamAirQualityRangeModerateL = singleParamAirQualityRange[MODERATE_L];
    let singleParamAirQualityRangeModerateU = singleParamAirQualityRange[MODERATE_U];
    let singleParamAirQualityRangePoorL = singleParamAirQualityRange[POOR_L];
    let singleParamAirQualityRangePoorU = singleParamAirQualityRange[POOR_U];
    let singleParamAirQualityRangeVPoorL = singleParamAirQualityRange[V_POOR_L];
    let singleParamAirQualityRangeVPoorU = singleParamAirQualityRange[V_POOR_U];
    let singleParamAirQualityRangeHighSevereL= singleParamAirQualityRange[HIGH_SEVERE_L];
    let singleParamAirQualityRangeHighSevereU = singleParamAirQualityRange[HIGH_SEVERE_U];
    
    const val = value;
    if(val == 0){ return { backgroundColor: '#c00000', textColor: '#ffffff'}; }
    const rangesData = [
      { max: singleParamAirQualityRangeVPoorL, colors: { backgroundColor: '#c00000', textColor: '#ffffff' } }, // Critical
      { max: singleParamAirQualityRangePoorL, colors: { backgroundColor: '#ff0000', textColor: '#ffffff' } }, // High Risk
      { max: singleParamAirQualityRangeModerateL, colors: { backgroundColor: '#ffa500', textColor: '#ffffff' } }, // Needs Attention
      { max: singleParamAirQualityRangeSatisfactoryL, colors: { backgroundColor: '#FFD700', textColor: '#000000' } }, // Marginally Acceptable
      { max: singleParamAirQualityRangeGoodL, colors: { backgroundColor: '#9acd32', textColor: '#ffffff' } }, // Hygienic
      { max: 100, colors: { backgroundColor: '#50C878', textColor: '#ffffff' } }  // Excellent (use 100.01 to ensure 100 is included)
    ];
    for (const range of rangesData) { if (val <= range.max) { return range.colors; } }
    return rangesData[rangesData.length - 1].colors;
  }

  const clampedValue = Math.max(0, Math.min( 100, hhqiValue));
  const pinPosition = `${100 - clampedValue}%`;

  const barHeight = 13;
  const circleDiameter = 37;
  const bandWidth = 4;
  const markerColors = getMarkerColor(hhqiValue);

  // --- Style Definitions ---
  const containerStyle = { /* ... styles remain the same ... */
    position: 'relative', width: '100%', marginBottom: '10px',
   };
  // const progressBarStyle = { /* ... styles remain the same ... */
  //   height: `${barHeight}px`, borderRadius: `${barHeight / 2}px`, overflow: 'hidden',
  //   background: `linear-gradient(to right, #50C878, #9acd32, #ffd700, #ffa500, #ff0000, #c00000)`,
  //   boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.2)', position: 'relative',
  // };
  const progressBarStyle = {
    height: `${barHeight}px`,
    borderRadius: `${barHeight / 2}px`,
    overflow: 'hidden',
    background: `linear-gradient(to right,
      #50C878 0%, #50C878 ${stdAirQualityRanges[HHQI][GOOD_PERCENT_U]}%,          /* Green: 0–5% */
      #9acd32 ${stdAirQualityRanges[HHQI][SATISFACTORY_PERCENT_L]}%, #9acd32 ${stdAirQualityRanges[HHQI][SATISFACTORY_PERCENT_U]}%,         /* Light Green: 5–15% */
      #ffd700 ${stdAirQualityRanges[HHQI][MODERATE_PERCENT_U]}%, #ffd700 ${stdAirQualityRanges[HHQI][MODERATE_PERCENT_L]}%,        /* Yellow: 15–25% */
      #ffa500 ${stdAirQualityRanges[HHQI][POOR_PERCENT_L]}%, #ffa500 ${stdAirQualityRanges[HHQI][POOR_PERCENT_U]}%,        /* Orange: 25–50% */
      #ff0000 ${stdAirQualityRanges[HHQI][VPOOR_PERCENT_L]}%, #ff0000 ${stdAirQualityRanges[HHQI][VPOOR_PERCENT_U]}%,        /* Red: 50–75% */
      #c00000 ${stdAirQualityRanges[HHQI][SEVERE_PERCENT_U]}%, #c00000 100%        /* Dark Red: 75–100% */
    )`,
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.2)',
    position: 'relative',
    zIndex: 5,
  };
  const markerBandStyle = { /* ... styles remain the same ... */
    position: 'absolute', bottom: '0', left: pinPosition, transform: 'translateX(-50%)',
    width: `${bandWidth}px`, height: `${barHeight}px`, backgroundColor: '#4a4a4a',
    borderRadius: '2px', boxShadow: '0 0 3px rgba(0, 0, 0, 0.4)', zIndex: 11,
  };
  const markerCircleStyle = { /* ... styles remain the same ... */
    position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)',
    width: `${circleDiameter}px`, height: `${circleDiameter}px`, borderRadius: '50%',
    backgroundColor: markerColors.backgroundColor, color: markerColors.textColor,
    border: `2px solid rgba(255, 255, 255, 1)`, display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: '13px', fontWeight: '900', zIndex: 12,
  };

  // Called when Info Button is clicked.
  const toggleFromInfoButton = (shortNameOfParam) => {
    let modifiedState = state;
    modifiedState.modalFromInfoButton = !state.modalFromInfoButton;    
    modifiedState.paramToShowDetailedInfo = shortNameOfParam;                          
    
    setState({...modifiedState});
  }

  useEffect(() => {

    getAirQualityRangesAndModelInfo();
    
  }, []);

  // get air quality ranges to show in Details and Ranges Modal
  const getAirQualityRangesAndModelInfo = () => {
      
    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t;  
    let modifiedState = state;

    modifiedState.arrOfRanges = [];
    modifiedState.arrOfDispRangeValues = [];

    axios.post(`${getAPIHostURL()}/wclient/getAirQualityRangeAndModelInfo`)
    .then(response => {
        if(response.data.code = "SUCCESS") {

            if(response.data["AirQualityRanges"] == null || response.data["AirQualityRanges"].length <=0
            ) {
                modifiedState.errors = t(IDS_LoginServerIssue);
            } else {
                let arrAirQualityRanges = response.data["AirQualityRanges"];
                let MeasuredParam;
                let HighLow;

                try {
                    for(let i=0; i < arrAirQualityRanges.length; i++){
                        let singleAirQualityRangeValues = arrAirQualityRanges[i];
                        MeasuredParam = singleAirQualityRangeValues.MeasuredParam;

                        HighLow = arrAirQualityRanges[i].RangeValues;
                        let singleRangeValues = {
                            MeasuredParam: MeasuredParam,
                            ...HighLow
                        }
                        modifiedState.stdAirQualityRanges[MeasuredParam] = singleRangeValues;
                    }

                    let arrOfRangesOfSelectedParam = modifiedState.stdAirQualityRanges["HHQI"] != null ? 
                        modifiedState.stdAirQualityRanges["HHQI"]['DispRngSeq'] : [] ;

                    if(arrOfRangesOfSelectedParam != null && arrOfRangesOfSelectedParam.length > 0){
                        arrOfRangesOfSelectedParam.forEach((childSnapshot) => {
                            modifiedState.arrOfRanges.push(Object.keys(childSnapshot)[0]);
                            modifiedState.arrOfDispRangeValues.push(Object.values(childSnapshot)[0]);
                        });
                    }  
                    
                } catch (error) {
                    console.log(`Should not happen. The data obtained from server is in invalid JSON format.`);
                    // Skip this device information and move to next
                }

                // show Details and Ranges old or new model based on if impacts for those params are present.
                // PARAM_FOR_SHOWING_IMPACTS contains all the parameters which have impacts.
                for(let i=0; i<PARAM_FOR_SHOWING_IMPACTS.length; i++) {
          
                    if(PARAM_FOR_SHOWING_IMPACTS[i] == "HHQI") {
                        modifiedState.showImpactsOfParam = true;
                        break;           
                    } else {
                        modifiedState.showImpactsOfParam = false;
                    }
                }

                setState({...modifiedState});

            }
        } else {
            
            if (response.data.code == 'SQL_ERROR') {
                // Tell the user that Server is experiencing errors
                modifiedState.errors = t(IDS_LoginServerIssue);
            } else {
                console.log('Should not reach here');
                modifiedState.errors = t(IDS_LoginServerIssue);
            }
            this.setState(modifiedState);
        }
    })
    .catch( error => {
        // Tell the user that there are network issues
        console.log(error);
        if (axios.isCancel(error)) {
            console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
        } else {
            modifiedState.errors = t(IDS_RegistNetworkError);
            this.setState(modifiedState);
        }
    }); 
  }

  const getRangeNameAndStyleBasedOnValue = (inParamValue, inParamNameType) => {
    let modifiedState = state;
    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t; 

    let rangeToDisplay = "";   // If need to show Current Range in future.

    let singleParamAirQualityRange = {};

    try {
        singleParamAirQualityRange = modifiedState.stdAirQualityRanges[inParamNameType];
    } catch(e) {
        console.log(`Should not happen. Param [${inParamNameType}] was not found in stdAirQualityRange. Might happen during first Render.`);
        // Return Default styles if stdAirQualityRange missing.
        return {RangeNameToShow: "", RangeBgColor: "lightGrey"};
        
    }
    if(singleParamAirQualityRange == null) {
        console.log(`Should not happen. Param [${inParamNameType}] was not found in stdAirQualityRange. Might happen during first Render.`);
        // Return Default styles if stdAirQualityRange missing.
        return {RangeNameToShow: "", RangeBgColor: "lightGrey"};
    }

    let singleParamAirQualityRangeLowSevereL = singleParamAirQualityRange[LOW_SEVERE_L];
    let singleParamAirQualityRangeLowSevereU = singleParamAirQualityRange[LOW_SEVERE_U];
    let singleParamAirQualityRangeGoodL = singleParamAirQualityRange[GOOD_L];
    let singleParamAirQualityRangeGoodU = singleParamAirQualityRange[GOOD_U];
    let singleParamAirQualityRangeSatisfactoryL = singleParamAirQualityRange[SATISFACTORY_L];
    let singleParamAirQualityRangeSatisfactoryU = singleParamAirQualityRange[SATISFACTORY_U];
    let singleParamAirQualityRangeModerateL = singleParamAirQualityRange[MODERATE_L];
    let singleParamAirQualityRangeModerateU = singleParamAirQualityRange[MODERATE_U];
    let singleParamAirQualityRangePoorL = singleParamAirQualityRange[POOR_L];
    let singleParamAirQualityRangePoorU = singleParamAirQualityRange[POOR_U];
    let singleParamAirQualityRangeVPoorL = singleParamAirQualityRange[V_POOR_L];
    let singleParamAirQualityRangeVPoorU = singleParamAirQualityRange[V_POOR_U];
    let singleParamAirQualityRangeHighSevereL= singleParamAirQualityRange[HIGH_SEVERE_L];
    let singleParamAirQualityRangeHighSevereU = singleParamAirQualityRange[HIGH_SEVERE_U];
    if( inParamValue == null || (typeof inParamValue === 'string' && inParamValue.length <= 0)) { 

        // If in future, we need to show Current Range for Parameteres in Single Device Data.
        rangeToDisplay = '';    
    } else {
        if( ( singleParamAirQualityRangeLowSevereL == null && inParamValue <= singleParamAirQualityRangeLowSevereU ) ||
            ( singleParamAirQualityRangeLowSevereU == null && inParamValue > singleParamAirQualityRangeLowSevereL ) ||
            ( inParamValue > singleParamAirQualityRangeLowSevereL && inParamValue <= singleParamAirQualityRangeLowSevereU ) )
        {            
            rangeToDisplay = LOW_SEVERE; 

        } else if(( singleParamAirQualityRangeGoodL == null && inParamValue <= singleParamAirQualityRangeGoodU ) ||
                    ( singleParamAirQualityRangeGoodU == null && inParamValue > singleParamAirQualityRangeGoodL ) ||
                    ( inParamValue > singleParamAirQualityRangeGoodL && inParamValue <= singleParamAirQualityRangeGoodU ) )
        {
            rangeToDisplay = GOOD;

        } else if(( singleParamAirQualityRangeSatisfactoryL == null && inParamValue <= singleParamAirQualityRangeSatisfactoryU ) ||
                    ( singleParamAirQualityRangeSatisfactoryU == null && inParamValue > singleParamAirQualityRangeSatisfactoryL ) ||
                    ( inParamValue > singleParamAirQualityRangeSatisfactoryL && inParamValue <= singleParamAirQualityRangeSatisfactoryU ) )
        {
            rangeToDisplay = SATISFACTORY; 

        } else if(( singleParamAirQualityRangeModerateL == null && inParamValue <= singleParamAirQualityRangeModerateU ) ||
                    ( singleParamAirQualityRangeModerateU == null && inParamValue > singleParamAirQualityRangeModerateL ) ||
                    ( inParamValue > singleParamAirQualityRangeModerateL && inParamValue <= singleParamAirQualityRangeModerateU ) )
        {
            rangeToDisplay = MODERATE;


        } else if(( singleParamAirQualityRangePoorL == null && inParamValue <= singleParamAirQualityRangePoorU ) ||
                    ( singleParamAirQualityRangePoorU == null && inParamValue > singleParamAirQualityRangePoorL ) ||
                    ( inParamValue > singleParamAirQualityRangePoorL && inParamValue <= singleParamAirQualityRangePoorU ) )
        {
            rangeToDisplay = POOR;


        } else if(( singleParamAirQualityRangeVPoorL == null && inParamValue <= singleParamAirQualityRangeVPoorU ) ||
                    ( singleParamAirQualityRangeVPoorU == null && inParamValue > singleParamAirQualityRangeVPoorL ) ||
                    ( inParamValue > singleParamAirQualityRangeVPoorL && inParamValue <= singleParamAirQualityRangeVPoorU ) )
        {
            rangeToDisplay = V_POOR;


        } else if(( singleParamAirQualityRangeHighSevereL == null && inParamValue <= singleParamAirQualityRangeHighSevereU ) ||
                    ( singleParamAirQualityRangeHighSevereU == null && inParamValue > singleParamAirQualityRangeHighSevereL ) ||
                    ( inParamValue > singleParamAirQualityRangeHighSevereL && inParamValue <= singleParamAirQualityRangeHighSevereU ) )
        { 
            rangeToDisplay = HIGH_SEVERE;

        } else {
            // Default black/grey
            rangeToDisplay = '';  
        }
    }

    let selectedRangeNameAndColour = "";

    selectedRangeNameAndColour = showRangeNameAndColorForToilet(rangeToDisplay, HHQI);
   
    return {RangeNameToShow: selectedRangeNameAndColour.retRangeName, RangeBgColor: selectedRangeNameAndColour.retRangeBandColor,
        CurrentRange: rangeToDisplay
    };
  
  }

  const showRangeNameAndColorForToilet = (inStdRangName, inParamNameType) => {
    
    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t;  
    let retRangeName = '';
    let retRangeBandColor = '';

      switch(inStdRangName) {

          case GOOD:
              retRangeName = t(IDS_HHQIExcellent) 
              retRangeBandColor = '#50C878';
              break;
          case SATISFACTORY:
              retRangeName = t(IDS_HHQIHygienic) 
              retRangeBandColor = '#9acd32';
              break;
          case MODERATE:
              retRangeName = t(IDS_HHQIAcceptable) 
              retRangeBandColor = '#FFD700';
              break;
          case POOR:
              retRangeName = t(IDS_HHQICaution)
              retRangeBandColor = 'orange';
              break;
          case V_POOR:
              retRangeName = t(IDS_HHQIHighRisk)
              retRangeBandColor = 'red';
              break;
          case HIGH_SEVERE:
              retRangeName = t(IDS_HHQICritical) 
              retRangeBandColor = '#C00000';
              break;
          default:
              console.log(`Unable to get RangeName. Unknown Range Type: ${inStdRangName}`);
              retRangeName = "";
              retRangeBandColor = 'lightGrey';
              break;
      }
      
      return {"retRangeName": retRangeName, "retRangeBandColor": retRangeBandColor}
    }

  const getHygieneLevelMsgForHHQI = (inRangeName, HHQIValue) => {
  
    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t; 
    switch (inRangeName) {
        case LOW_SEVERE:
            return 'Hygiene level ' + inRangeName
        case GOOD:
            return t(IDS_HygieneMsgExcellent, Math.round(HHQIValue))
        case SATISFACTORY:
            return t(IDS_HygieneMsgHygienic, Math.round(HHQIValue))
        case MODERATE:
            return t(IDS_HygieneMsgAcceptable, Math.round(HHQIValue))
        case POOR:
            return t(IDS_HygieneMsgCaution, Math.round(HHQIValue))
        case V_POOR:
            return t(IDS_HygieneMsgHighRisk, Math.round(HHQIValue))
        case HIGH_SEVERE:
            return t(IDS_HygieneMsgCritical, Math.round(HHQIValue))
        default:
            return "Hygiene level " + inRangeName
    }
  }

  const HHQIBandColor = getRangeNameAndStyleBasedOnValue(hhqiValue, HHQI).RangeBgColor;
  const HHQIRangeName = getRangeNameAndStyleBasedOnValue(hhqiValue, HHQI).RangeNameToShow
  const HHQICurrentRangeMessage = getHygieneLevelMsgForHHQI(getRangeNameAndStyleBasedOnValue(hhqiValue, HHQI).CurrentRange, hhqiValue)

  return (
    showHHQI &&
      <div>
        <Row gutter={[16, 16]} >
          <Col xs={24} >
            <div className="custom-card shadow-sm"> {/* Ensure shadow-sm is here */}
              <div className="custom-card-header">
                <div className="custom-card-header-inner">
                  <span className="custom-card-title">
                    {t(IDS_HHQI)} (HHQI)
                  </span>
                  <span id="toggleSpan" className="tooltipForRangeIcon2" onClick={ () => toggleFromInfoButton(props.shortNameOfParam)}>
                    <FiInfo className="rangeIcon" style={{fontSize: "1.3rem", fontWeight: "bold"}}/>
                  </span>
                </div>
              </div>
              {/* Render children passed to CustomCard inside the body */}
              <div className="custom-card-body">          
                {/* Content goes directly inside CustomCard, which renders it in its body */}
                <div style={containerStyle}>
                  {/* The Progress Bar */}
                  <div
                    className="position-relative"
                    style={progressBarStyle}
                    role="progressbar"
                    aria-valuenow={hhqiValue}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label={`Risk level: ${hhqiValue}`}
                  ></div>

                  {/* The Marker Band */}
                  <div style={markerBandStyle}></div>

                  {/* The Marker Circle Container & Circle */}
                  <div style={{
                      position: 'absolute',
                      bottom: `${barHeight}px`,
                      left: pinPosition,
                      transform: 'translateX(-50%)',
                      width: `${circleDiameter}px`,
                      height: `${circleDiameter}px`,
                      zIndex: 12,
                  }}>
                    <div style={markerCircleStyle}>
                        {Math.round(hhqiValue)}
                    </div>
                  </div>
                </div>

                {/* Range labels */}
                {/* <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                    fontSize: '12px',
                    fontWeight: '700',
                    color: '#374151'
                  }}
                >
                  {ranges.map((range, index) => (
                    <div
                      key={index}
                      style={{
                        flex: '1',
                        textAlign: 'center',
                        padding: '0 2px',
                        wordBreak: 'break-word',
                      }}
                    >
                      {range.label}
                    </div>
                  ))}
                </div> */}
                {(HHQIBandColor == null || HHQIBandColor == "lightGrey" || HHQIBandColor == "" ||
                HHQIRangeName == null || HHQIRangeName == "" || HHQIRangeName == "lightGrey" || 
                HHQICurrentRangeMessage == null || HHQICurrentRangeMessage == "" || hhqiValue == null || hhqiValue === "")
                ?
                <div></div>
                :
                <div>
                  <div
                    style={{
                      marginTop: "1rem",
                      borderLeft: `4px solid ${HHQIBandColor}`,  
                      paddingLeft: "0.8rem",
                      textAlign: "left",
                      fontFamily: "'Segoe UI', sans-serif",
                      color: "#1c1c1e",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "1rem", fontWeight: 600, color: HHQIBandColor, display: "flex", alignItems: "center" }}>
                        {/* <span style={{ fontSize: "1.1rem", marginRight: "0.4rem" }}>✅</span> */}
                        <span>{t(IDS_Hygiene)} {t(IDS_status)} - {HHQIRangeName}</span>
                      </div>
                      <div style={{ fontSize: "0.93rem", marginTop: "0.3rem", lineHeight: "1.6"}}>
                        {/* HHQI is <strong>{Math.round(hhqiValue)}</strong>, indicating a clean, fresh, and well-maintained toilet environment. */}
                        {/* <br /> */}
                        {/* Hygiene efforts are on point — <span style={{ fontStyle: "italic" }}>keep shining!, indicating a clean, fresh, and well-maintained toilet environment.</span> */}
                        {HHQICurrentRangeMessage} 
                      </div>
                    </div>
                  </div>
                </div>
                } 
                <div>
                  <VcInfoBox
                      showInfoBox = {false}
                      flag={true}
                      // getParamValueTextAndBoxStyleBasedOnRange={getParamValueTextAndBoxStyleBasedOnRange}
                      SingleDeviceParamValue={hhqiValue}  
                      stdAirQualityRanges={props.stdAirQualityRanges}
                      SingleDeviceParamSequence = {props.SingleDeviceParamSequence}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Modal
          size="xl"
          isOpen={state.modalFromInfoButton}
          toggle={toggleFromInfoButton}
          backdrop={state.backdropForInfoButton}
          centered // Good for modern look
        >
          <ModalHeader toggle={toggleFromInfoButton}>
            {t(IDS_WhatIsHHQI)}
          </ModalHeader>
          <ModalBody>
          <div style={{border:"1px solid var(--primaryColor)", backgroundColor:"rgb(168,204,168,0.3)", borderRadius:"0.3rem", marginTop:"0.5rem", padding:"0.1rem", height: "42rem", overflow: "auto"}}>              
            <div style={{marginLeft: "0.5rem", marginRight: "0.5rem", textAlign: "left"}} 
              dangerouslySetInnerHTML={{ __html: t(IDS_HHQIInfo) }}
            />
            <h3 class = "mainHeadings" style={{ margin: "1rem 0 0.5rem", fontWeight: "600", color: "#2d2d2d", fontSize: "1.3rem", marginLeft: "1rem"}}>
              {t(IDS_DetailsAndRangesHHQI)}
            </h3>
            <div class="cardHeadForDetailsAndRanges">
              <VcDetailsAndRanges arrOfRanges={state.arrOfRanges} arrOfDispRangeValues={state.arrOfDispRangeValues} selectedParamToViewRangeDetails={"HHQI"}
                  showImpactsOfParam={state.showImpactsOfParam}
                  invokedFrom={"paramDoc"}
            />           
            </div>         
          </div>
          </ModalBody>
        </Modal>
      </div>
  );
};

export default HHQIDashboard;